// import appLocaleData from 'react-intl/locale-data/th';
import thMessages from '../locales/th_TH'
import myAdminTHMessages from '../locales/my-admin-th_TH'
import advTHMsg from '../locales/adv-th_TH';
import asmTHMsg from '../locales/asm-th_TH';
import evaTHMsg from '../locales/eva-th_TH';
import grdTHMsg from '../locales/grd-th_TH';
import tncTHMsg from '../locales/tnc-th_TH';
import tnfTHMsg from '../locales/tnf-th_TH';
import curThMessages from '../locales/cur-th_TH';

const ThLang = {
    messages: {
        ...thMessages,
        ...myAdminTHMessages,
        ...advTHMsg,
        ...asmTHMsg,
        ...evaTHMsg,
        ...grdTHMsg,
        ...tncTHMsg,
        ...tnfTHMsg,
        ...curThMessages,
    },
    locale: 'th-TH',
    // data: appLocaleData
};
export default ThLang;
